import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getMediaProjectCloseTasks(data) {
    return request.get(`/${platform}/media_project_close_tasks`,data)
}

export function uploadMediaProjectCloseTasks(data) {
    const url = `/${platform}/media_project_close_tasks/upload`
    return request.post(url, data)
}

export function tryAgainMediaProjectCloseTasks(data) {
    const url = `/${platform}/media_project_close_tasks/try_again`
    return request.post(url, data)
}

export function deleteAdvertiserProjects(data) {
    const url = `/${platform}/media_project_close_tasks/delete_advertiser_projects`
    return request.post(url, data)
}
